/**
 * Snippet: Newsletter Sign-up Form
 * ------------------------------------------------------------------------------
 * Connects to the Como API
 *
 * @namespace newsletterSingupForm
 */


if (!customElements.get('newsletter-signup-form')) {

  class NewsletterSingupForm extends HTMLElement {
    constructor() {
      super()

      // Get the generic string value from the form data (the location)
      this.location = this.dataset.location ? this.dataset.location : 'Online';
      // Get message container for errors
      this.messageContainer = this.querySelector('.como-form__message');
      //get button to add event listener
      this.button = this.querySelector('.como-form__btn');
      //set constant message
      this.successMessage = "You've successfully subscribed!";

      if (!this.messageContainer || !this.button) return;

      //add event listener
      this.button.addEventListener("click", this.getData.bind(this));
    }

    // Get field values from mini Como form
    getData(event) {
      // Prevent the default form submission behavior
      event.preventDefault();
      this.button.disabled = true;
      console.log("Footer button disabled");
      
      // Get the email value from the form input
      this.email = this.querySelector('.como-form__input__email');
      this.emailValue = this.email.value;

      // Call the API function with the email value
      if (this.emailValue && this.email.checkValidity()) {
          this.registerCustomerEmail(this.emailValue);
      // Error if email value isn't valid or filled out
      } else {
        this.messageContainer.dataset.status = 'error';
        this.messageContainer.innerHTML = "Looks like something is missing. Please check that your email is correct and try again.";
        this.button.disabled = false;
      }
    };

    // Call to the lambda function
    registerCustomerEmail(email) {
      const apiUrl = 'https://register-email-como.alisha-garric.workers.dev';

      const requestData = {
        email: email,
        location: this.location
      };

      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      console.log(`${apiUrl}?email=${requestData.email}&genericString1=${requestData.location ? requestData.location : "Online"}`);

      // Main fetch method to the lambda function
      fetch(`${apiUrl}?email=${requestData.email}&genericString1=${requestData.location ? requestData.location : "Online"}`, requestOptions)
        .then(response => response.json())
        .then(data => {

          //If new subscriber, ask them to fill out more fields
          if (data.status === 'ok') {
            this.fetchPopUp(email);

          //If existing subscriber, fail
          } else if (data.status === 'error') {
            this.messageContainer.dataset.status = 'error';
            this.messageContainer.innerHTML = 'Looks like you’re already subscribed! Thanks for shopping with Buff City Soap & we hope to see you at the Makery soon!';
            this.button.disabled = false;
          }
        })
        .catch(error => {
          console.error('Error:', error);
          this.button.disabled = false;
        });
    }

    //Pop up with more Como fields
    fetchPopUp(email) {
      console.log(`section_id=store-page-sign-up-section`)

      //Fetch existing Como form section
      fetch(`${window.location.pathname}?section_id=store-page-sign-up-section`)
        .then((response) => response.text())
        .then((text) => {
          let html = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".shopify-section store-page-sign-up");

            this.buildPopUp(html, email);
        })
        .catch((error) => {
          //If section fetch fails, output success message for submitted email from previous step
          this.messageContainer.dataset.status = 'success';
          this.messageContainer.innerHTML = this.successMessage;
          console.error(error);
          this.button.disabled = false;
        });
    }

    //Close pop up
    closePopUp(e) {
      console.log(e.target.classList);
      if (e.target.classList.contains("como-form__exit") || e.target.classList.contains("como-form--pop-up")) {
        this.container.remove();
        document.body.style.overflow = 'unset';
      }
    }

    buildPopUp(formHtml, email) {
      
      // Get footer to append pop up to
      this.footer = document.getElementById("page-footer");
      
      // Get exit button to close pop up
      this.exit = formHtml.querySelector('.como-form__exit');

      // Get email input to modify with already provided email
      this.readOnlyEmail = formHtml.querySelector(".como-form__input__email");

      if (this.footer && formHtml && this.readOnlyEmail) {
        
        //add unique success message to pull
        formHtml.dataset.successMessageOverride = "Thanks for signing up! We hope to see you at the Makery soon.";
        formHtml.dataset.offerTag = formHtml.dataset.defaultNoOfferTag;

        //modify with already provided email
        this.readOnlyEmail.setAttribute('value', email);
        this.readOnlyEmail.setAttribute('readonly', true);

        //prevent scroll
        document.body.style.overflow = 'hidden';

        //append pop up with container into footer
        this.container = document.createElement("div");
        this.container.classList.add("como-form--pop-up");
        this.container.appendChild(formHtml);
        this.footer.appendChild(this.container);

        //add event listener
        this.exit.addEventListener("click", this.closePopUp.bind(this));
        this.container.addEventListener("click", this.closePopUp.bind(this));
        this.button.disabled = false;

      } else {
        //If something fails, output success message for submitted email from previous step
        this.messageContainer.dataset.status = 'success';
        this.messageContainer.innerHTML = this.successMessage;
        this.button.disabled = false;
      }
    }
  }

  customElements.define('newsletter-signup-form', NewsletterSingupForm);
}